export enum IntersectionType {
  None = 'None',
  Include = 'Include',
  Exclude = 'Exclude',
}

const ALL_PERMISSIONS = [
  'selections.labmanager',
  'selections.salesrepresentative',
  'selections.b2bnotifications',
  'selections.copy',
  'selections.generate',
  'selections.edit',
  'selections.create',
  'selections.delete',
  'selections',
  'notification.orderingprovider.create',
  'notification.patient.create',
] as const;

export type Permission = (typeof ALL_PERMISSIONS)[number];
